export default __webpack_public_path__ + "static/media/wall animals.36e36e7a.jpg";